import { useFeatureGate } from "@statsig/react-bindings";
import { useCallback } from "react";
import { enableZoomGate } from "../statsig/gates";
import { Statsig } from "../statsig/StatsigProvider";

/**
 * Determines if Zoom video integration is enabled for the current user.
 * This hook implements a provider-dependent feature pattern where patient access
 * to Zoom functionality depends on their provider's Statsig allocation.
 *
 * Uses a feature gate with "providerShortID" (case-sensitive) as the
 * Statsig ID Type, defined as a customID on the StatsigUser.
 * @see gracefullyUpdateStatsigUser for user configuration details
 */
export function useIsZoomEnabled(): [boolean, () => boolean] {
  const { value } = useFeatureGate(enableZoomGate);
  const checkZoomIsEnabled = useCallback(() => {
    return Statsig.checkGate(enableZoomGate);
  }, []);

  return [value, checkZoomIsEnabled];
}
